import React from "react";
import { Link } from "gatsby";

const Button = ({ data }) => {
  console.info("Button", data);
  if (!data) {
    return null;
  }
  return (
    <div className="mx-auto max-w-screen-xl xxl:max-w-screen-3xl">
      {data.OpenNewTab ? (
        <a
          href={data.Link}
          target={`${data.OpenNewTab ? "_blank" : "_parent"}`}
          className={` bg-orange rounded-lg px-5 py-2 font-display font-bold text-base text-white no-underline hover:text-black  border-2 border-orange hover:bg-white 	transition duration-500 mt-2 inline-block w-auto `}
        >
          {data.Label}
        </a>
      ) : (
        <Link
          to={data.Link}
          target={`${data.OpenNewTab ? "_blank" : "_parent"}`}
          className={` bg-orange rounded-lg px-5 py-2 font-display font-bold text-base text-white no-underline hover:text-black  border-2 border-orange hover:bg-white 	transition duration-500 mt-2 inline-block w-auto`}
        >
          {data.Label}
        </Link>
      )}
    </div>
  );
};

export default Button;
